import React from 'react';
import { useSelector } from 'react-redux';

import { usePokerSundayMillionWidget } from '../../../model';
import TilesList from '../../TilesList/TilesList';

import Chip from './Chip/Chip';
import { TXTCLI_MAIN_EVENT, TXTCLI_Win_a_Ticket } from './EventContent.messages.json';
import styles from './EventContent.scss';
import Section from './Section/Section';
import Sidecar from './Sidecar/Sidecar';

const EventContent: React.FC = () => {
  const { widgetSelect } = usePokerSundayMillionWidget();
  const tournament = useSelector(widgetSelect.getTournament);
  const isLoading = useSelector(widgetSelect.isLoading);

  if (!isLoading && !tournament) return null;

  return (
    <div className={styles.root}>
      <Section alignment="left" translation={TXTCLI_Win_a_Ticket} showSkeleton={isLoading}>
        <TilesList />
      </Section>
      <Section>
        <Chip />
      </Section>
      <Section alignment="right" translation={TXTCLI_MAIN_EVENT} showSkeleton={isLoading}>
        <Sidecar />
      </Section>
    </div>
  );
};

export default EventContent;
